export class ClassroomClient {
  public static closeIframe() {
    window.parent.postMessage(
      { type: 'Classroom', action: 'closeIframe' },
      '*',
    );
  }
}
